import { Field, LinkField, RichTextField, LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C10SuggestiveDropdownListProps = RenderingProps<
  C10SuggestiveDropdownListFields,
  C10SuggestiveDropdownListParams
>;

export type C10SuggestiveDropdownListFields = {
  suggestiveDropdown?: {
    headline?: Field<string>;
    supportCopy?: RichTextField;
    cTA?: LinkField;
    listOfLinks?: C10SuggestiveDropdownLinkListFields;
  };
};

export type C10SuggestiveDropdownLinkListFields = {
  Links?: {
    value?: Array<LinkFieldValue>;
  };
};
export type C10SuggestiveDropdownListParams = {
  HeadlineTag?: string;
  Background?: string;
  ContentAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
